const mostRecentLookupPrefix = 'dmcMostRecentlyViewed_'

/**
 * Stores the identifier for the most recently viewed resource of a certain type.
 * Ideally, this method should be called only when the resource was fetched
 * successfully.
 * @param context the type of resource
 * @param value the identifier for the resource
 */
export const setMostRecentlyViewed = (context, value) => {
  sessionStorage.setItem(mostRecentLookupPrefix + context, value)
}

/**
 * Retrieves the identifier for the most recently viewed resource of a certain
 * type. This allows users to return to a tab and see what they viewed most
 * recently. This data is only stored until the end of the current browser session.
 * @param context the type of resource
 */
export const getMostRecentlyViewed = (context) => sessionStorage.getItem(mostRecentLookupPrefix + context)
